module.exports = __webpack_public_path__ + "img/15.a63c0af1.jpg";